export const UsuarioEntity = {
    id: null,
    username: '',
    password: '',
    nombres: '',
    apellidos: '',
    fecNacimiento: null,
    email: '',
    telefono: '',
    docIdentidad: '',
    tipoDocumento: 'DNI',
    profileImage: '',
    profile: {
        id: null,
        name: '',
        permissions: []
    }
};